/** @format */

import React from 'react';
import Link from '@base-components/buttons';
import Translate from '@components/translation/translate-text-wrapper';

/**
 * Countdown Banner.
 */
const CountdownBanner: React.FC<{
  title: string | null;
  subtitle: string | null;
  additionalText?: string | null;
  linkText?: string | null;
  linkUrl?: string;
  disclaimer?: string;
  postBanner: boolean;
  mobileBanner?: string;
  desktopBanner?: string;
  dateTime?: Date | null;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  completed?: boolean;
}> = ({
  title,
  subtitle,
  additionalText,
  disclaimer,
  linkText,
  linkUrl,
  postBanner,
  mobileBanner,
  desktopBanner,
  dateTime,
  days,
  hours,
  minutes,
  seconds,
  completed,
}) => {
  /**
   * Render.
   */
  return (
    <div className="grid-2-columns reverse">
      <div className="grid-item center-vertically">
        <div className="text-content center-vertically">
          <h2 className="font-size-xl">{title}</h2>
          {subtitle && subtitle !== '' && <h3>{subtitle}</h3>}
          {additionalText && additionalText !== '' && <p>{additionalText}</p>}

          {linkUrl && linkUrl !== '' && linkText && linkText !== '' && (
            <div className="link-container">
              <Link classes={`btn-primary`} linkText={linkText} url={linkUrl} />
            </div>
          )}

          {!postBanner && !completed && (
            <time
              dateTime={dateTime.toTimeString()}
              className="countdown-container">
              <div className="countdown-timer">
                <div className="count-type">
                  <Translate useJson={false}>Days</Translate>
                </div>
                <div className="days">{days}</div>
              </div>
              <div className="countdown-timer">
                <div className="count-type">
                  <Translate useJson={false}>Hours</Translate>
                </div>
                <div className="hours">{hours}</div>
              </div>
              <div className="countdown-timer">
                <div className="count-type">
                  <Translate useJson={false}>Minutes</Translate>
                </div>
                <div className="minutes">{minutes}</div>
              </div>
              <div className="countdown-timer">
                <div className="count-type">
                  <Translate useJson={false}>Seconds</Translate>
                </div>
                <div className="seconds">{seconds}</div>
              </div>
            </time>
          )}

          {disclaimer && disclaimer !== '' && (
            <p className="font-semibold disclaimer">{disclaimer}</p>
          )}
        </div>
      </div>

      <div className="img-container center-vertically cover">
        {mobileBanner && (
          <img
            src={`${mobileBanner}?w=720&quality=40`}
            className=" visible-sm-block visible-xs-block img-responsive rounded-corners lazy"
            alt={title ?? ''}
          />
        )}
        {desktopBanner && (
          <img
            src={`${desktopBanner}?w=720&h=720&quality=40&crop=true`}
            className="visible-md-block visible-lg-block img-responsive rounded-corners lazy"
            alt={title ?? ''}
          />
        )}
      </div>
    </div>
  );
};
export default CountdownBanner;
